// counter.actions.ts
import { Action } from '@ngrx/store';
import { Company } from '../models/company'

export const SET_SHOW_CASHFLOW = '[Company] SET_SHOW_CASHFLOW';

export const FETCH_COMPANY = '[Company] FETCH_COMPANY';
export const FETCH_COMPANY_SUCCESS = '[Company] FETCH_COMPANY_SUCCESS';
export const FETCH_COMPANY_FAILURE = '[Company] FETCH_COMPANY_FAILURE';
export const CLEAR = 'CLEAR';

export class Clear implements Action {
  readonly type = CLEAR;
  constructor() { }
}

export class SetShowCashflow implements Action {
  readonly type = SET_SHOW_CASHFLOW;
  constructor(public payload: boolean) { }
}

export class FetchCompany implements Action {
  readonly type = FETCH_COMPANY;
  constructor(public payload: string) { }
}

export class FetchCompanySuccess implements Action {
  readonly type = FETCH_COMPANY_SUCCESS;
  constructor(public payload: Company) {
  }
}

export class FetchCompanyFailure implements Action {
  readonly type = FETCH_COMPANY_FAILURE;
  constructor(public payload: any) {}
}

export type Actions = Clear | FetchCompany | FetchCompanySuccess
| FetchCompanyFailure | SetShowCashflow;



// WEBPACK FOOTER //
// ./src/actions/company.actions.ts